export const whiteListFileTypes = [
    "jpg",
    "png",
    "jpeg",
    "gif",
    "csv",
    "doc",
    "docb",
    "docm",
    "docx",
    "dot",
    "dotm",
    "dotx",
    "pdf",
    "xla",
    "xlam",
    "xll",
    "xlm",
    "xls",
    "xlsb",
    "xslm",
    "xlsx",
    "xlt",
    "xltm",
    "xltx",
    "xlw",
    "xml",
    "rar",
    "zip",
];
